import { MenuItemAdmin, MenuItemFormData } from "../types/menuItem";
import { get, post } from "./fetch.core";

export async function fetchMenuItemList() {
  const res = await get<MenuItemAdmin[]>("/admin/menuItem/list");
  return res.data;
}

export async function getMenuItem(menuItemId: string) {
  const res = await get<MenuItemAdmin>(`/admin/menuItem/get?menuItemId=${menuItemId}`);
  return res.data;
}

export async function createMenuItem(data: MenuItemFormData) {
  if (data.type === "category") {
    const res = await post("/admin/menuItem/create", {
      type: "category",
      categoryId: data.categoryId,
      order: data.order,
    });
    return res.data;
  }
  const res = await post("/admin/menuItem/create", {
    type: "link",
    label: data.label,
    href: data.href,
    order: data.order,
  });
  return res.data;
}

export async function updateMenuItem(menuItemId: string, data: MenuItemFormData) {
  if (data.type === "category") {
    const res = await post("/admin/menuItem/update", {
      menuItemId,
      type: "category",
      categoryId: data.categoryId,
      order: data.order,
    });
    return res.data;
  }
  const res = await post("/admin/menuItem/update", {
    menuItemId,
    type: "link",
    label: data.label,
    href: data.href,
    order: data.order,
  });
  return res.data;
}

export async function deleteMenuItem(menuItemId: string) {
  const res = await post("/admin/menuItem/delete", { menuItemId });
  return res.data;
}

export async function reOrderMenuItems(menuItemIds: string[]) {
  const res = await post("/admin/menuItem/reOrder", { menuItemIds });
  return res.data;
}
